import { Component, Vue } from 'vue-property-decorator';
import { ShareViewModel } from './Share.types';
import { getComponentProps } from '@/utils/vueUtils';

const ShareProps = Vue.extend({
  props: getComponentProps<ShareViewModel>({
    Url: 'https://d3t9z7c45vc1rg.cloudfront.net/',
    Title: 'title goes here',
    Description: 'Description goes here',
    Hashtags: 'itinerary,travel,lindblad',
    Quote: 'quote goes here - facebook',
    TwitterUser: 'LindbladExp',
  }),
});

@Component({})
export default class Share extends ShareProps {
  get shareTitle() {
    return this.p.Title.replace('Share ', '');
  }
}
